export default __webpack_public_path__ + "static/media/Edit-pen.d9c776a7.svg";